<template>
    <USelect
              v-model="sortBy"
              :items="sortOptions"
              option-attribute="label"
              value-attribute="value"
              class="w-48"
            />
</template>
<script setup lang="ts">
const { t } = useI18n()
const sortOptions = [
  { label: t('Relevance'), value: 'relevance' },
  { label: 'Popularity', value: 'popularity' },
  { label: t('Lowest price'), value: 'price_asc' },
  { label: t('Highest price'), value: 'price_desc' },
  // { label: 'Newest Arrivals', value: 'newest' }
]
const props = defineProps<{
  modelValue?: string
}>()
const emit = defineEmits<{
  (e: 'update:modelValue', v: string): void
}>()
const sortBy = computed({
  get: () => props.modelValue,
  set: (value: string) => {
    emit('update:modelValue', value)
  }
})
</script>